import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "container-node-tab" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "node-tab" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(), _createBlock(_Fragment, null, _renderList(7, (ver) => {
      return _createVNode("div", {
        class: "grid grid-cols-7 gap-8 mb-3 row-node-tab",
        key: ver
      }, [
        (_openBlock(), _createBlock(_Fragment, null, _renderList(7, (hor) => {
          return _createVNode("div", { key: hor }, [
            _hoisted_2
          ])
        }), 64))
      ])
    }), 64))
  ]))
}